var _filter, _marker, _marker2, _marker3, _rect, _text, _rect2, _text2, _g, _g2, _g3, _g4, _rect3, _text3, _g5, _path, _path2, _path3, _g6, _g7, _g8, _g9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg05NatTranslation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 450",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "deviceGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6366f1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#4f46e5"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "routerGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f59e0b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#d97706"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "internetGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#06b6d4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0891b2"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadowCard",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodOpacity: 0.25
  }))), _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "arrowBlue",
    markerWidth: 10,
    markerHeight: 7,
    refX: 9,
    refY: 3.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3.5, 0 7",
    fill: "#6366f1"
  }))), _marker2 || (_marker2 = /*#__PURE__*/React.createElement("marker", {
    id: "arrowOrange",
    markerWidth: 10,
    markerHeight: 7,
    refX: 9,
    refY: 3.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3.5, 0 7",
    fill: "#f59e0b"
  }))), _marker3 || (_marker3 = /*#__PURE__*/React.createElement("marker", {
    id: "arrowCyan",
    markerWidth: 10,
    markerHeight: 7,
    refX: 9,
    refY: 3.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3.5, 0 7",
    fill: "#06b6d4"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 450,
    fill: "#0f172a"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 40,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 24,
    fontWeight: "bold"
  }, "\n    How NAT Translation Works\n  ")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 80,
    width: 280,
    height: 300,
    rx: 16,
    fill: "#1e1b4b",
    opacity: 0.4,
    stroke: "#6366f1",
    strokeWidth: 2
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 110,
    textAnchor: "middle",
    fill: "#a5b4fc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 600
  }, "\n    \uD83C\uDFE0 Home Network (Private)\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(90, 180)",
    filter: "url(#shadowCard)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -45,
    y: -35,
    width: 90,
    height: 70,
    rx: 10,
    fill: "url(#deviceGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    y: -5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "\uD83D\uDCBB Laptop"), /*#__PURE__*/React.createElement("text", {
    y: 15,
    textAnchor: "middle",
    fill: "#c7d2fe",
    fontFamily: "monospace",
    fontSize: 11
  }, "192.168.1.2"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(220, 180)",
    filter: "url(#shadowCard)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -45,
    y: -35,
    width: 90,
    height: 70,
    rx: 10,
    fill: "url(#deviceGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    y: -5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "\uD83D\uDCF1 Phone"), /*#__PURE__*/React.createElement("text", {
    y: 15,
    textAnchor: "middle",
    fill: "#c7d2fe",
    fontFamily: "monospace",
    fontSize: 11
  }, "192.168.1.3"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(170, 320)",
    filter: "url(#shadowCard)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -40,
    width: 140,
    height: 80,
    rx: 12,
    fill: "url(#routerGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    y: -10,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 16,
    fontWeight: "bold"
  }, "\uD83D\uDD00 NAT Router"), /*#__PURE__*/React.createElement("text", {
    y: 12,
    textAnchor: "middle",
    fill: "#fef3c7",
    fontFamily: "monospace",
    fontSize: 10
  }, "Private: 192.168.1.1"), /*#__PURE__*/React.createElement("text", {
    y: 28,
    textAnchor: "middle",
    fill: "#fde68a",
    fontFamily: "monospace",
    fontSize: 10
  }, "Public: 203.0.113.45"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(380, 150)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 10,
    fill: "#1e293b",
    stroke: "#475569",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 25,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: "bold"
  }, "NAT Translation Table"), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 40,
    x2: 170,
    y2: 40,
    stroke: "#475569",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 60,
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10
  }, "Internal"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 60,
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10
  }, "External"), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 70,
    x2: 170,
    y2: 70,
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 90,
    fill: "#a5b4fc",
    fontFamily: "monospace",
    fontSize: 10
  }, "192.168.1.2:4532"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 90,
    fill: "#fde68a",
    fontFamily: "monospace",
    fontSize: 10
  }, "203.0.113.45:10001"), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 115,
    fill: "#a5b4fc",
    fontFamily: "monospace",
    fontSize: 10
  }, "192.168.1.3:8080"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 115,
    fill: "#fde68a",
    fontFamily: "monospace",
    fontSize: 10
  }, "203.0.113.45:10002"), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 140,
    fill: "#a5b4fc",
    fontFamily: "monospace",
    fontSize: 10
  }, "192.168.1.2:9999"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 140,
    fill: "#fde68a",
    fontFamily: "monospace",
    fontSize: 10
  }, "203.0.113.45:10003"), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 75,
    width: 160,
    height: 20,
    rx: 4,
    fill: "#6366f1",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.2;0.4;0.2",
    dur: "2s",
    repeatCount: "indefinite"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 80,
    width: 280,
    height: 300,
    rx: 16,
    fill: "#134e4a",
    opacity: 0.3,
    stroke: "#14b8a6",
    strokeWidth: 2
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 730,
    y: 110,
    textAnchor: "middle",
    fill: "#5eead4",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 600
  }, "\n    \uD83C\uDF10 Internet (Public)\n  ")), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(730, 230)",
    filter: "url(#shadowCard)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -50,
    width: 120,
    height: 100,
    rx: 12,
    fill: "url(#internetGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    y: -15,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "\uD83D\uDDA5\uFE0F google.com"), /*#__PURE__*/React.createElement("text", {
    y: 10,
    textAnchor: "middle",
    fill: "#cffafe",
    fontFamily: "monospace",
    fontSize: 12
  }, "142.250.80.46"), /*#__PURE__*/React.createElement("text", {
    y: 30,
    textAnchor: "middle",
    fill: "#a5f3fc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10
  }, "External Server"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 130 215 L 130 275",
    stroke: "#6366f1",
    strokeWidth: 3,
    markerEnd: "url(#arrowBlue)",
    strokeDasharray: "6,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-18",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 240 320 Q 400 320 550 280",
    stroke: "#f59e0b",
    strokeWidth: 3,
    markerEnd: "url(#arrowOrange)",
    strokeDasharray: "8,4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-24",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 590 260 L 670 240",
    stroke: "#14b8a6",
    strokeWidth: 3,
    markerEnd: "url(#arrowCyan)",
    strokeDasharray: "6,3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-18",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(90, 250)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 14,
    fill: "#6366f1"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: "bold"
  }, "1"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(350, 295)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 14,
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: "bold"
  }, "2"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(620, 270)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 14,
    fill: "#14b8a6"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: "bold"
  }, "3"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 410)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#a5b4fc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, /*#__PURE__*/React.createElement("tspan", {
    fontWeight: "bold",
    fill: "#6366f1"
  }, "1."), " Device sends with private IP\n    "), /*#__PURE__*/React.createElement("text", {
    x: 250,
    fill: "#fcd34d",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, /*#__PURE__*/React.createElement("tspan", {
    fontWeight: "bold",
    fill: "#f59e0b"
  }, "2."), " NAT replaces with public IP + random port\n    "), /*#__PURE__*/React.createElement("text", {
    x: 560,
    fill: "#5eead4",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, /*#__PURE__*/React.createElement("tspan", {
    fontWeight: "bold",
    fill: "#14b8a6"
  }, "3."), " Server sees only public IP\n    "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg05NatTranslation);
export default __webpack_public_path__ + "static/media/05-nat-translation.6022a6bcc7e4dbf44b8533aec0e11daf.svg";
export { ForwardRef as ReactComponent };